import React from 'react'
import { withTranslation } from 'react-i18next';
import WarningIcon from '../../../images/advarsel2.png'

const Eiendom = (props) => {
    var eiendom = props.eiendom;

    var infoList = []
    if (eiendom.utgattarsak) {
        infoList.push(props.t('utgatt'))
        infoList.push(eiendom.utgattarsak.substr(eiendom.utgattarsak.indexOf('-')+1, eiendom.utgattarsak.length))
    }

    if (eiendom.tilmatrikkelenhet)
        infoList.push(eiendom.tilmatrikkelenhet)
    
    return(
        <li className="resultitem" onClick={() => props.onSelectResult(eiendom)}>
            <span className="title">{eiendom.matrikkelnummer} ({props.t('eiendom')})</span>
            { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
            <div>{props.t('kommune')}: {eiendom.kommunenavn}</div>
        </li>
    )
  }

export default withTranslation('common')(Eiendom)